import styled from 'styled-components';
import { visibilityStyles, StyledVisibilityProps } from 'src/app/atoms/Layout/Visibility.styles';

interface PositionProps {
  left?: string | number;
  right?: string | number;
  top?: string | number;
  bottom?: string | number;
}

interface AbsolutePositionedAssetContainerProps extends StyledVisibilityProps {
  $position: PositionProps;
  $maxWidth?: string | number;
  $width?: string | number;
  $zIndex?: number;
}

const formatValue = (value: string | number): string => {
  if (typeof value === 'number') return `${value}px`;
  return value;
};

export const AbsolutePositionedAssetContainer = styled.div<AbsolutePositionedAssetContainerProps>`
  position: absolute;
  ${({ $position }) => $position.left !== undefined && `left: ${formatValue($position.left)};`}
  ${({ $position }) => $position.right !== undefined && `right: ${formatValue($position.right)};`}
  ${({ $position }) => $position.top !== undefined && `top: ${formatValue($position.top)};`}
  ${({ $position }) => $position.bottom !== undefined && `bottom: ${formatValue($position.bottom)};`}
  ${({ $maxWidth }) => $maxWidth !== undefined && `max-width: ${formatValue($maxWidth)};`}
  ${({ $width }) => $width !== undefined && `width: ${formatValue($width)};`}
  ${({ $zIndex }) => $zIndex !== undefined && `z-index: ${$zIndex};`}
  --layout-display-property: block;

  ${visibilityStyles}
`;
